import React, { useState } from "react";
import { siteData } from "../data/mockData";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const [activeSection, setActiveSection] = useState("home");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    setMobileMenuOpen(false);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navLinks = [
    { id: "home", label: "Home" },
    { id: "services", label: "Services" },
    { id: "about", label: "About us" },
  ];

  return (
    <nav className="w-full bg-white py-4 px-6 md:px-16 sticky top-0 z-50 shadow-sm">
      <div className="max-w-[1400px] mx-auto flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => scrollToSection("home")}>
          <img
            src="/logo_teal.png"
            alt="Anish Total Dental Care"
            className="w-10 h-10 object-contain"
          />
          <div className="flex flex-col">
            <span className="font-poppins font-bold text-[#1a1a1a] text-base leading-tight">
              Anish Total
            </span>
            <span className="font-poppins text-[#1a1a1a] text-sm leading-tight">
              Dental Care
            </span>
          </div>
        </div>

        {/* Desktop Nav Links */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className={`font-poppins text-[15px] transition-colors bg-transparent border-none cursor-pointer ${
                activeSection === link.id
                  ? "text-[#1CA0B9] font-medium"
                  : "text-[#333] hover:text-[#1CA0B9]"
              }`}
            >
              {link.label}
            </button>
          ))}
        </div>

        {/* Appointment Button */}
        <a
          href={`tel:${siteData.clinic.phone}`}
          className="hidden md:inline-flex items-center justify-center bg-[#1CA0B9] text-white font-poppins font-medium text-sm px-7 py-2.5 rounded-full hover:bg-[#1890a5] transition-colors"
        >
          Appointment
        </a>

        {/* Mobile Menu Toggle */}
        <button
          className="md:hidden text-[#1a1a1a] bg-transparent border-none cursor-pointer"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden mt-4 pb-4 border-t border-gray-100">
          <div className="flex flex-col gap-3 pt-4">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className={`font-poppins text-[15px] text-left bg-transparent border-none cursor-pointer py-2 ${
                  activeSection === link.id
                    ? "text-[#1CA0B9] font-medium"
                    : "text-[#333]"
                }`}
              >
                {link.label}
              </button>
            ))}
            <a
              href={`tel:${siteData.clinic.phone}`}
              className="inline-flex items-center justify-center bg-[#1CA0B9] text-white font-poppins font-medium text-sm px-7 py-2.5 rounded-full mt-2 w-fit"
            >
              Appointment
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
